import { createContext } from "react";


const LocationContext = createContext({
    pickupPlace: null,
    dropOffPlace: null,
    country: null,
    countryCode: null,
    setPickUpLocation: (place) => { },
    setDropoffLocation: (place) => { },
});

export default LocationContext;